// src/types/documents.types.ts

export enum DocumentType {
  PASSPORT_FRONT = 'PASSPORT_FRONT',
  PASSPORT_BACK = 'PASSPORT_BACK',
  UTILITY_BILL = 'UTILITY_BILL',
  BANK_STATEMENT = 'BANK_STATEMENT',
  SELFIE = 'SELFIE',
  DRIVERS_LICENCE_FRONT = 'DRIVERS_LICENCE_FRONT',
  DRIVERS_LICENCE_BACK = 'DRIVERS_LICENCE_BACK',
  GOVERNMENT_ID_FRONT = 'GOVERNMENT_ID_FRONT',
  GOVERNMENT_ID_BACK = 'GOVERNMENT_ID_BACK'
}

export enum DocumentStatus {
  PENDING = 'PENDING',
  UPLOADED = 'UPLOADED',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED'
}

export interface DocumentInfo {
  documentType: DocumentType;
  status: DocumentStatus;
  fileName?: string;
}

export interface DocumentsInfoData {
  documents: DocumentInfo[];
  allDocsUploaded: boolean;
}

export interface ValidationErrors {
  [key: string]: string;
}

export interface FileUploadResponse {
  success: boolean;
  message: string;
  currentPhase: string;
  data: {
    documentType: DocumentType;
    status: DocumentStatus;
    allDocsUploaded: boolean;
    fileName?: string;
  };
}

export interface DeleteDocumentResponse {
  success: boolean;
  message: string;
  currentPhase: string;
  data: {
    documentType: DocumentType;
    status: DocumentStatus;
    allDocsUploaded: boolean;
  };
}

// Actualizado para coincidir con el uso en el componente
export interface DocumentConfig {
  type: DocumentType;
  title: string;
  description: string;
  required: boolean;
}

// Actualizado para coincidir con la estructura de la respuesta del servidor
export interface DocumentsResponse {
  success: boolean;
  message: string;
  data: {
      documents: Record<string, {
          file?: string;
          status?: DocumentStatus;
          documentType?: string;
      }>;
      allDocsUploaded: boolean;
      passportFrontType?: string;
      passportBackType?: string;
  };
}

// Actualizado para ser compatible con el uso en el componente
export interface DocumentsState {
  [key: string]: {
      uploaded: boolean;
      fileName?: string;
      status?: DocumentStatus;
      error?: string;
  };
}

// Nueva interfaz para el tipo de documento de ID
export type IDDocumentType = 'PASSPORT' | 'DRIVERS_LICENCE' | 'GOVERNMENT_ID';

// Interfaz para la respuesta de actualización del tipo de documento
export interface UpdateDocumentTypeResponse {
  success: boolean;
  message: string;
  data: {
    documentField: string;
    documentType: string;
  };
}